<template>
  <!--    <div style="min-height: 500px">-->
  <div :style="component_style">
    <!--            计数器-->
    <div v-if="$common.isClient_whole()">
      <Wp_access_count v-if="store_channel_username" :page-tag="page_tag"></Wp_access_count>
    </div>
    <div v-else>
      <Wp_access_count :page-tag="page_tag"></Wp_access_count>
    </div>

    <Wp_nav_bar v-if="show_nav_bar" :title="title"></Wp_nav_bar>

    <div :style="{position: 'relative', top: top_px, marginBottom: topPx, minHeight: '250px'}">
      <div v-if="component_datas && component_datas.length > 0">
        <div v-for="(item, index) in component_datas" v-bind:key="index">
          <component
              v-bind:is="getComponentName(item.component)"
              :params="item.props"
              :list="item.list"
              :img-gray="img_gray"
              @hotItemAddToSelected="hotItemAddToSelected"
              v-if="$common.isShowComponent(item)"
          ></component>
        </div>
      </div>
      <div v-if="component_datas && component_datas.length > 0">
        <div v-if="getMoreData(component_datas)">
          <div v-if="more_search || more_filter">
            <Wp_jd_skulist_with_url_filter
                :list="more_datas.list"
                :search-box="more_search"
                :filter-box="more_filter"
            ></Wp_jd_skulist_with_url_filter>
          </div>
          <div v-else>
            <Wp_home_more_model
                v-if="more_datas.props && more_datas.props.hidden!==true"
                ref="Wp_home_more_model"
                :params="more_datas.props"
                :list="more_datas.list"
                :style="more_datas.props.style"
                :img-gray="img_gray"
            ></Wp_home_more_model>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Wp_home_more_model from './Wp_home_more_model'
import { Toast } from 'vant'
import Wp_access_count from '../custom/Wp_access_count'
import Wp_nav_bar from '../custom/Wp_nav_bar'
import Wp_jd_skulist_with_url_filter from '../pages_childs/Wp_jd_skulist_with_url_filter'

Vue.use(Toast)

export default {
  name: 'Wp_home_all_model',
  components: {
    Wp_jd_skulist_with_url_filter,
    Wp_nav_bar,
    Wp_access_count,
    Wp_home_more_model,
    Wp_home_banner_model: () => import('./Wp_home_banner_model.vue'),
    Wp_home_grid_model: () => import('./Wp_home_grid_model.vue'),
    Wp_home_news_model: () => import('./Wp_home_news_model.vue'),
    Wp_home_actives_model: () => import('./Wp_home_actives_model.vue'),
    Wp_home_hot_model: () => import('./Wp_home_hot_model.vue'),
    Wp_home_grid_data_model: () => import('./Wp_home_grid_data_model.vue'),
    Wp_home_search_model: () => import('./Wp_home_search_model.vue'),
    Wp_home_pop_model: () => import('./Wp_home_pop_model.vue'),
    Wp_home_content_model: () => import('./Wp_home_content_model.vue')
  },

  props: {
    // isLoading:{type: Boolean, default: false}
    parent: { type: Object, default: null },
    topPx: { type: String, default: '0px' }
  },
  data () {
    return {
      screenHeight:
          window.innerHeight ||
          document.documentElement.clientHeight ||
          document.body.clientHeight,

      component_name: 'Wp_home_banner_model',

      header_bg_color: '',
      header_font_color: '',
      component_style: '',
      component_datas: [],

      showLoading: true,
      loadingText: '加载中...',

      sub_path: '',
      channel_name: '',

      JdSelectListSheet_parent: null,

      more_datas: null,

      store_channel_username: '',
      img_gray: false,
      top_px: '0px',
      show_nav_bar: false,
      more_search: false,
      more_filter: false,

      page_tag: 'home',
      title: '限时活动'
    }
  },
  created () {
    // this.$log("this.$config.project = " + this.$config.project);
    this.top_px = this.topPx

    let _search = this.$common.getUrlKey('search_box')
    if (_search && _search === 'true') {
      this.more_search = true
    } else {
      this.more_search = false
    }

    let _filter = this.$common.getUrlKey('filter_box')
    if (_filter && _filter === 'true') {
      this.more_filter = true
    } else {
      this.more_filter = false
    }

    this.JdSelectListSheet_parent = this.parent

    // if(this.isTest()){
    //     this.initComponentDatasTest();
    // }else{
    //     this.initComponentDatas();
    // }

    this.initComponentDatas()
  },
  methods: {
    hotItemAddToSelected (skuInfo, skuId) {
      if (this.$refs.Wp_home_more_model) {
        this.$refs.Wp_home_more_model.addInSelectList(skuInfo, skuId)
      }
    },

    isTest () {
      let test = this.$common.getUrlKey('test')
      let url = window.location.href

      if (
          test &&
          (url.indexOf('localhost:') !== -1 || url.indexOf('192.168.') !== -1)
      ) {
        return true
      } else {
        return false
      }
    },

    refreshHome () {
      this.$log('refreshHome')
      this.component_style = ''
      this.component_datas = []
    },

    /**
     * 初始化推荐页的模板数据
     */
    initComponentDatas () {
      this.sub_path = this.$common.getUrlKey('sub_path')
      this.channel_name = this.$common.getUrlKey('channel_name')
      if (!this.channel_name) {
        let host = window.location.host
        // host = "a004.28pay.com";//test
        // this.$log("host = " + host);
        this.channel_name = host.substring(0, host.indexOf('.'))
      }

      if (this.$common.isClient_hm()) {
        let url = decodeURIComponent(window.location.href)
        this.$log('url = ' + url)
        if (url.indexOf('channel_name=') !== -1) {
          let temp_channel_name = url.substring(
              url.indexOf('channel_name=') + 'channel_name='.length
          )
          this.$log('temp_channel_name = ' + temp_channel_name)
          if (temp_channel_name.indexOf('&') !== -1) {
            temp_channel_name = temp_channel_name.substring(
                0,
                temp_channel_name.indexOf('&')
            )
          }
          this.channel_name = temp_channel_name
        }
      }

      let _url = ''
      if (this.sub_path) {
        _url = this.$common.get_home_datas_base + this.sub_path
        this.page_tag = this.sub_path
      } else {
        _url = this.$common.get_home_datas
        this.page_tag = 'home'
      }

      if (this.$common.isClient_whole()) {
        if (this.sub_path) {
          if (this.sub_path.indexOf('page_') !== -1) {
            _url = this.$common.get_home_datas_base + this.sub_path
          } else {
            _url = this.$common.get_home_datas_base + 'home_client'
          }
          this.page_tag = this.sub_path
        } else {
          _url = this.$common.get_home_datas_base + 'home_client'
          this.page_tag = 'home'
        }
        _url = _url.replace(' ', '')

        // _url = this.$common.get_home_datas_base + "home_client";
        // _url = this.$common.get_home_datas_base + "page_1581905112_test";
      }

      if (this.channel_name && this.$common.isClient_whole()) {
        this.$getPid(this.channel_name, res => {
          this.$log(res)
          if (res.code === 200) {
            // let _channel_id=res.data.channel_id;
            let _channel_id = res.data.jd_channel_id
            let _channel_name = res.data.channel_name
            let _channel_pdd_pid = ''
            if (res.data.pdd_channel_id) {
              _channel_pdd_pid = res.data.pdd_channel_id
            }
            let _channel_tb_pid = ''
            if (res.data.tb_channel_id) {
              _channel_tb_pid = res.data.tb_channel_id
            }
            let user = {
              username: _channel_name, //_channel_name
              userId: _channel_name,
              pid: _channel_id,
              pdd_pid: _channel_pdd_pid,
              tb_pid: _channel_tb_pid,
            }
            // this.$store.commit('login', user);
            this.$store.commit('saveChannelData', user)
            //将登录状态修改为false，以确保群主登录后台时需重新登录
            // this.$store.commit("setLoginStatus", false);
            this.store_channel_username = this.$store.state.channel_username
            this.$log(
                'this.store_channel_username = ' + this.store_channel_username
            )
          }
        })
      }

      let loadingToast = Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      })

      this.$getDatasWithUrlAndParams(_url, null, response => {
        if (response && response.code === 200) {
          if (response.data) {
            let _props = response.data.props
            this.component_style = _props.style
            if (this.JdSelectListSheet_parent) {
              this.JdSelectListSheet_parent.bg_color = _props.header_bg_color
              this.JdSelectListSheet_parent.font_color =
                  _props.header_font_color
            }

            if (_props.title) {
              this.title = _props.title
            }

            let colors = {
              bg_color: _props.header_bg_color,
              font_color: _props.header_font_color
            }
            if (
                _props.header_bg_color.toLowerCase() === '#aaaaaa' ||
                _props.header_bg_color.toLowerCase() === '#aaa'
            ) {
              this.img_gray = true
            }

            this.$emit('getColors', colors)

            if (response.data.list && response.data.list.length > 0) {
              this.component_datas = response.data.list

              //临时小程序审核时使用
              // this.component_datas.splice(1,1);

              if (
                  this.component_datas &&
                  this.component_datas.length === 1 &&
                  this.component_datas[0].component === 'more'
              ) {
                this.top_px = '0px'
                this.show_nav_bar = true
                if (this.more_search || this.more_filter) {
                  this.show_nav_bar = false
                }
              }
            } else {
              //如果list为空，则不显示首页
              if (this.JdSelectListSheet_parent) {
                this.JdSelectListSheet_parent.showHome = false
                this.JdSelectListSheet_parent.showTabsHome = false
              }
              this.$common.transparent = false
            }
          }
        }

        //小程序测试使用
        // if(this.$common.gloabl_wx_mini_user_info && this.$common.gloabl_wx_mini_user_info.id){
        //     let ids = "7BC6DBC7CD7CDCDAA1F22822CE1FCE39;C56565C08708F8D59C9DCD6AD8D60BA6";
        //     if(ids.toLowerCase().indexOf(this.$common.gloabl_wx_mini_user_info.id.toLowerCase()) === -1){
        //
        //         this.JdSelectListSheet_parent.showHome = false;
        //         this.JdSelectListSheet_parent.showTabsHome = false;
        //         this.$common.transparent = false;
        //     }
        // }

        // loadingToast.message="加载完成";
        setTimeout(() => {
          //关闭下拉刷新
          if (this.JdSelectListSheet_parent) {
            this.JdSelectListSheet_parent.isLoading = false
          }

          this.showLoading = false
          loadingToast.clear()
        }, 500)
      })
    },

    initComponentDatasTest () {
      let _props = this.testComponent.data.props
      this.component_style = _props.style
      this.component_datas = this.testComponent.data.list
      this.JdSelectListSheet_parent.bg_color = _props.header_bg_color
      this.JdSelectListSheet_parent.font_color = _props.header_font_color
      setTimeout(() => {
        //关闭下拉刷新
        this.JdSelectListSheet_parent.isLoading = false
        this.showLoading = false
      }, 500)
    },

    /**
     * 获取对应的模板
     */
    getComponentName (_component) {
      if (_component.props && _component.props.hidden === true) {
        return null
      }
      if (_component === 'banner') {
        return 'Wp_home_banner_model'
      } else if (_component === 'grid') {
        return 'Wp_home_grid_model'
      } else if (_component === 'pop') {
        return 'Wp_home_pop_model'
      } else if (_component === 'news') {
        return 'Wp_home_news_model'
      } else if (_component === 'content') {
        return 'Wp_home_content_model'
      } else if (_component === 'actives') {
        return 'Wp_home_actives_model'
      } else if (_component === 'hot') {
        return 'Wp_home_hot_model'
      } else if (_component === 'grid_data') {
        return 'Wp_home_grid_data_model'
      } else if (_component === 'grid_mini') {
        //小程序专用的grid
        if (
            this.$common.gloabl_wx_mini_user_info &&
            this.$common.gloabl_wx_mini_user_info.id
        ) {
          return 'Wp_home_grid_model'
        } else {
          return null
        }
      } else if (_component === 'search') {
        return 'Wp_home_search_model'
      }
      // else if(_component === "more"){
      //     return "Wp_home_more_model";
      // }
    },

    getMoreData (component_datas) {
      for (let i = 0; i < component_datas.length; i++) {
        if (component_datas[i].component === 'more') {
          this.more_datas = component_datas[i]
          return this.more_datas
        }
      }
      return null
    }
  }
}
</script>

<style scoped>
</style>